


































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class DirectSalesProposalProgress extends Vue {
  @Prop({ default: 1 }) step: number;
}
